module.exports = __webpack_public_path__ + "static/img/headshot-1.f4033b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headshot-1.png
// module id = 25
// module chunks = 1